export class SecretVerificationRequest {
  masterPasswordHash: string;
  otp: string;
  authRequestAccessCode: string;
}
